import { CheckboxField } from '@monorepo/shared/componentsV2/fields/CheckboxField';
import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import { FormTemplateFieldTypes } from 'mapistry-shared';
import React from 'react';
import { useField } from 'react-final-form';
import styled from 'styled-components';
import { ModalFieldWrapper } from '../styled';

type EditIsProtectedFieldProps = {
  prefix?: string;
};

const protectableFieldTypes = new Set([
  FormTemplateFieldTypes.BOOLEAN,
  FormTemplateFieldTypes.DATE,
  FormTemplateFieldTypes.MULTI_LOCATION,
  FormTemplateFieldTypes.MULTI_SELECT_WITH_FREE_FORM,
  FormTemplateFieldTypes.MULTI_SELECT,
  FormTemplateFieldTypes.MULTI_USER,
  FormTemplateFieldTypes.NUMBER,
  FormTemplateFieldTypes.PHONE_NUMBER,
  FormTemplateFieldTypes.PHOTO_CAROUSEL,
  FormTemplateFieldTypes.SIGNATURE,
  FormTemplateFieldTypes.SINGLE_LOCATION,
  FormTemplateFieldTypes.SINGLE_SELECT_WITH_FREE_FORM,
  FormTemplateFieldTypes.SINGLE_SELECT,
  FormTemplateFieldTypes.TEXT_AREA,
  FormTemplateFieldTypes.TEXT,
  FormTemplateFieldTypes.TIME,
  FormTemplateFieldTypes.USER,
  // todo@protectedFields: add DocumentUploader here once we allow document fields to be filled in stencils
]);

const StyledCheckboxField = styled(CheckboxField)`
  margin-bottom: 0.5rem;
`;

export function EditIsProtectedField({ prefix }: EditIsProtectedFieldProps) {
  const {
    input: { value: fieldType },
  } = useField<FormTemplateFieldTypes>(getFieldNameWithPrefix('type', prefix));

  if (!protectableFieldTypes.has(fieldType)) {
    return null;
  }

  return (
    <ModalFieldWrapper>
      <StyledCheckboxField
        name={getFieldNameWithPrefix('isProtected', prefix)}
        label="Locked"
        helperText="If a default value is provided here or in the site template, non-admin users will see the default value and will not be able to edit it."
      />
    </ModalFieldWrapper>
  );
}
